var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPageLast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-double-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9752 10.0006L10.6647 5.6901L9.68264 6.67219L13.011 10.0006L9.68264 13.329L10.6647 14.3111L14.9752 10.0006ZM11.0517 10.0006L6.74116 5.6901L5.75907 6.67219L9.0875 10.0006L5.75907 13.329L6.74116 14.3111L11.0517 10.0006Z",
    fill: "#0A0D14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageLast);
export default __webpack_public_path__ + "static/media/icon-page-last.d05fa2c08966919e44d1df09fe8ae7e2.svg";
export { ForwardRef as ReactComponent };